module.exports = __webpack_public_path__ + "img/01.43e38cec.jpg";